import { render, staticRenderFns } from "./ComplaintScreeningReceivedSummary.vue?vue&type=template&id=9ee87810&"
import script from "./ComplaintScreeningReceivedSummary.vue?vue&type=script&lang=js&"
export * from "./ComplaintScreeningReceivedSummary.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintScreeningReceivedSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports